import { IAgoraRTC } from "agora-rtc-sdk-ng"

let agoraIsImported = false
export function safeImportAgora() {
    if (typeof window === "undefined") {
        console.warn("Tried to import Agora from the server")
        return
    }
    const AgoraRTC: IAgoraRTC =
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        require("agora-rtc-sdk-ng").default || require("agora-rtc-sdk-ng")
    agoraIsImported = true
    return AgoraRTC
}
export function isAgoraImported() {
    return agoraIsImported
}
